module.exports = __webpack_public_path__ + "static/media/img_g3.58b8a66e.webp";